function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M75.377,0H45.111L6.284,36.258l20.268,21.7c7.994-7.041,12.753-12.185,14.277-15.417H41.4v3.427 c0,7.613-0.05,19.126-0.144,34.545c-0.096,15.417-0.144,27.027-0.144,34.831H10.562v28.266h95.646v-28.266H75.377V0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505.489,73.232c-1.816-1.809-3.952-2.712-6.43-2.712H151.886c-2.474,0-4.611,0.903-6.423,2.712 c-1.805,1.809-2.708,3.949-2.708,6.424v54.817c0,2.475,0.9,4.615,2.708,6.424c1.812,1.807,3.949,2.712,6.423,2.712h347.176 c2.478,0,4.617-0.905,6.427-2.712c1.808-1.809,2.707-3.949,2.707-6.424V79.656C508.2,77.182,507.297,75.041,505.489,73.232z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.664,420.834l27.123-32.833v-25.125H5.712v43.396h30.262V391.14c3.046,0,7.661-0.086,13.85-0.277 c6.182-0.195,10.8-0.288,13.846-0.288v0.288c-3.621,3.426-7.139,7.087-10.566,10.992c-3.427,3.904-7.471,9.041-12.135,15.409 c-4.661,6.379-7.751,10.521-9.275,12.423l7.421,15.988c19.985-1.526,29.979,3.802,29.979,15.988c0,5.328-2.046,9.373-6.139,12.128 c-4.089,2.766-8.897,4.145-14.417,4.145c-10.848,0-20.937-4.281-30.262-12.85L1.998,490.211 c12.562,12.562,28.931,18.843,49.109,18.843c15.416,0,28.31-4.374,38.688-13.131c10.373-8.758,15.559-20.749,15.559-35.974 c0-9.709-2.859-18.083-8.562-25.129C91.08,427.784,83.375,423.116,73.664,420.834z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.942,298.066h-36.26c0.193-4.76,3.571-9.756,10.138-14.985c6.567-5.232,13.747-10.037,21.555-14.417 c7.801-4.381,14.939-10.514,21.412-18.412c6.472-7.9,9.707-16.608,9.707-26.125c0-13.515-4.757-24.222-14.273-32.121 c-9.514-7.898-21.223-11.849-35.117-11.849c-11.042,0-21.083,2.712-30.124,8.138c-9.04,5.424-15.843,12.991-20.412,22.701 l24.27,16.844c6.663-11.042,14.371-16.56,23.125-16.56c4.762,0,8.52,1.285,11.281,3.854c2.757,2.574,4.141,6.235,4.141,10.994 c0,4.377-2.238,8.66-6.711,12.847c-4.475,4.187-9.851,8.326-16.134,12.419c-6.28,4.093-12.563,8.615-18.842,13.563 c-6.28,4.949-11.661,11.417-16.134,19.411c-4.471,7.994-6.708,16.847-6.708,26.553c0,3.425,0.571,8.565,1.711,15.417H105.92 v-45.402v-0.004H75.942V298.066z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.06,362.876H151.886c-2.663,0-4.853,0.858-6.563,2.569c-1.713,1.712-2.568,3.901-2.568,6.564v54.819 c0,2.475,0.9,4.616,2.708,6.423c1.812,1.808,3.949,2.711,6.423,2.711h347.176c2.478,0,4.617-0.896,6.427-2.711 c1.808-1.807,2.707-3.948,2.707-6.423V372.01c0-2.471-0.906-4.613-2.707-6.42C503.676,363.782,501.537,362.876,499.06,362.876z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.06,216.698H151.886c-2.663,0-4.853,0.855-6.563,2.568c-1.713,1.713-2.568,3.903-2.568,6.567v54.818 c0,2.475,0.9,4.613,2.708,6.424c1.812,1.81,3.949,2.714,6.423,2.714h347.176c2.478,0,4.617-0.904,6.427-2.714 c1.808-1.811,2.707-3.949,2.707-6.424v-54.818c0-2.474-0.906-4.615-2.707-6.423C503.676,217.602,501.537,216.698,499.06,216.698z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgOlist = function SvgOlist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 509.054 509.054",
    style: {
      enableBackground: "new 0 0 509.054 509.054"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/olist.dc5ea94c.svg";
export { ForwardRef as ReactComponent };